import { render, staticRenderFns } from "./CouponPutin.vue?vue&type=template&id=29a5dc10&scoped=true&"
import script from "./CouponPutin.vue?vue&type=script&lang=ts&"
export * from "./CouponPutin.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPutin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CouponPutin.vue?vue&type=style&index=1&id=29a5dc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a5dc10",
  null
  
)

export default component.exports